import React from "react";
import { WebInsightCard } from "../../components/WebInsightCard";
import "./style.css";

export const Desktop = () => {
  return (
    <div className="desktop">
      <div className="hero">
        <div className="overlap-group">
          <img className="group" alt="Group" src="./img/group-7.png"/>
          <div className="text-wrapper">Studio Blij</div>
        </div>
      </div>
      <div className="frame">
        <div className="div">
          <div className="text-wrapper-2">Ontwerpvraag</div>
          <p className="p">
            <span className="span">&#39;&#39;Hoe kunnen we ervoor zorgen dat we </span>
            <span className="text-wrapper-3">patiënten</span>
            <span className="span"> met een </span>
            <span className="text-wrapper-3">vochtrestrictie, </span>
            <span className="span">middels het </span>
            <span className="text-wrapper-3">bijhouden van een consistente tussenmeting, helpen</span>
            <span className="span"> bij te sturen met een </span>
            <span className="text-wrapper-3">gepaste vocht inname</span>
            <span className="span">?&#39;&#39;</span>
          </p>
        </div>
        <div className="frame-2">
          <div className="text-wrapper-4">Doelgroep</div>
          <p className="p">
            Patiënten met een vochtrestrictie die na ontslag uit het ziekenhuis thuis hun vochtinname dienen bij te
            houden.
          </p>
        </div>
      </div>
      <div className="frame-3">
        <img className="vector" alt="Vector" src="./img/vector.svg" />
        <div className="text-wrapper-5">Inzichten</div>
        <div className="frame-4">
          <div className="text-wrapper-6">Regels en richtlijnen vochtinname</div>
        </div>
        <div className="frame-5">
          <WebInsightCard
            className="WEB-INSIGHT-CARD-instance"
            description={
              <>
                Doe dit tijdens de maaltijd.
                <br />
                Neem je medicatie in met een eetlepel appelmoes of yoghurt. Dit zorgt ervoor dat onnodig vocht in wordt
                genomen zoals een heel glas water.
                <br />
                Maar sommige medicijnen mogen niet met lactose ingenomen worden. Dus neem het voor de zekerheid in met
                je maaltijd of met een eetlepel appelmoes.
              </>
            }
            title={
              <>
                Het volgende wordt aangeraden <br />
                om je medicatie in te nemen:
              </>
            }
          />
          <WebInsightCard
            className="WEB-INSIGHT-CARD-instance"
            description={
              <>
                Vocht kan zich ophopen in de longen waardoor benauwdheid en vermoeidheid ontstaat.
                <br />
                Oedemen (= vochtophoping bij enkels, handen, hart, longen, enzovoort)
                <br />
                Toename buikomvang (zorgt ook voor een mindere eetlust)
                <br />
                Toename gewicht.
              </>
            }
            title="Vocht vasthouden symptomen:"
          />
          <WebInsightCard
            className="WEB-INSIGHT-CARD-instance"
            description={
              <>
                Een gemiddelde warme maaltijd (drie opscheplepels groente, drie aardappelen, portie vlees en jus) bevat
                ongeveer 400 ml vocht. Als u in plaats van de warme maaltijd een gelijke hoeveelheid soep of pap eet,
                hoeft u daarvoor dus&nbsp;&nbsp;geen vocht te laten staan. Eet u twee warme maaltijden per dag, dan moet
                u dit vocht wel in mindering brengen op uw&nbsp;&nbsp;totale drinkvocht van die dag. Voor 100 gram
                groenten wordt er 100 ml vocht geteld.
                <br />
                <br />
                Elk stuk fruit wat u neemt telt mee voor de vochtrestrectie voor elk portie fruit reken je 100 ml vocht.
                Een gemiddelde portie fruit weegt 125- 150 gram. 1 stuk fruit is bijvoorbeeld: 1 appel, 2 kiwi’s, 2
                mandarijnen, 2 kiwi’s, 1 peer, 1 handje&nbsp;&nbsp;druiven.
                <br />
                <br />
                Vloeibare voedingsmiddelen die met een lepel gegeten worden zoals soep, pap, vla, yoghurt, appelmoes,
                compote en ijs.(vocht in &#39;vaste&#39; voedingsmiddelen worden dus niet geteld, zoals: jam, jus, saus,
                vocht in groente en vlees). Een schaaltje vla of yoghurt bevat al snel 150 ml vocht.
              </>
            }
            title="De volgende dingen tellen mee als vocht:"
          />
          <WebInsightCard
            className="WEB-INSIGHT-CARD-instance"
            description={
              <>
                Zout, er zit natrium in wat er voor zorgt dat het lichaam vocht vasthoudt. Verder geeft het ook een
                dorstig gevoel waardoor je meer wilt gaan drinken.
                <br />
                Alcohol zorgt ook voor een dorstig gevoel maar vooral dat je medicatie niet goed werkt.
                <br />
                Overmatig transpireren, braken en diarree wat veroorzaakt wordt door warm tropisch weer of korts zorgen
                ook voor veel vochtverlies. in overleg met hun arts kunnen patiënten vragen of ze meer mogen drinken en
                het innemen van de plaspillen.
              </>
            }
            title="Dingen waar rekening mee gehouden moeten worden tijdens de vochtrestrictie:"
          />
          <p className="inzicht-in-de">
            Inzicht in de huidige manier <br />
            van het bijhouden van de vochtinname
          </p>
        </div>
        <WebInsightCard
          className="WEB-INSIGHT-CARD-instance"
          description="De huidige technologieën / methoden van het bijhouden van vochtinname zijn omslachtig en outdated. Hiernaast zijn ze ook niet flexibel. Vaak heeft de gebruiker maar één manier van invoeren van hun vochtinname."
          title="Beschikbare technologieën omslachtig"
        />
        <WebInsightCard
          className="WEB-INSIGHT-CARD-instance"
          description="Het te obsessief bijhouden kan ook teveel focus leggen op de gezondsheidsproblemen die de gebruiker ervaart. Er moet wel een balans zijn en toegankelijk wil je de last hiervan ontnemen."
          title="Onderhouden van de gezondheid"
        />
        <WebInsightCard
          className="WEB-INSIGHT-CARD-instance"
          description="Een gemiddelde warme maaltijd (drie opscheplepels groente, drie aardappelen, samen met een portie vlees en jus) bevat ongeveer 400 ml vocht. Patienten zijn hier niet voldoende van bewust en weten dit niet goed / voldoende bij te houden."
          title="Maaltijden tellen ook als vochtinname"
        />
        <div className="frame-wrapper">
          <div className="frame-4">
            <p className="text-wrapper-6">Gebruiken van huidige apparaten / oplossingen</p>
            <div className="frame-6">
              <WebInsightCard
                className="WEB-INSIGHT-CARD-instance"
                description="Draagbare wearables, slimme (urine)containers zijn beschikbare technologieën voor automatische monitoring van vochtinname."
                title="Beschikbare technologie"
              />
              <WebInsightCard
                className="WEB-INSIGHT-CARD-instance"
                description="Technologieën met datafusie bieden de meest veelbelovende resultaten voor monitoring van vochtinname. Oftewel, wanneer meerdere data inputs samen worden gevoegd."
                title="Beschikbare technologie"
              />
              <WebInsightCard
                className="WEB-INSIGHT-CARD-instance"
                description="Op visie gebaseerde methoden voor inname monitoring tonen potentieel voor niet-intrusieve monitoring van voedsel en vocht."
                title="Beschikbare technologie"
              />
              <WebInsightCard
                className="WEB-INSIGHT-CARD-instance"
                description="Sensoren hebben potentie om een nauwkeurige registratie van eetgedrag in real-life omgevingen te bieden."
                title="Beschikbare technologie"
              />
              <WebInsightCard
                className="WEB-INSIGHT-CARD-instance"
                description="De psychologische effecten van consumentdraagbare apparaten worden vaak over het hoofd gezien. Sommige gebruikers nemen gezondere gewoontes aan, terwijl anderen obsessief, bezorgd of gestrest kunnen raken. Dit door bijvoorbeeld door herinnert te worden aan gezondsheidsproblemen, maar ook als de resultaten (vochtinname) niet gelijk zijn aan waar ze in eerste instantie op hoopte."
                title="Risico’s en valkuilen"
              />
              <WebInsightCard
                className="WEB-INSIGHT-CARD-instance"
                description="Patiënten kunnen geen aanpassingen maken of reageren op veranderingen in real-time door onvoldoende responsiviteit van meetapparaten."
                title="Risico’s en valkuilen"
              />
            </div>
          </div>
        </div>
        <img className="img" alt="Vector" src="./img/vector-1.svg" />
      </div>
      <div className="frame-7">
        <div className="text-wrapper-7">Ontwerprichtlijnen</div>
        <div className="frame-8">
          <div className="frame-9">
            <div className="text-wrapper-8">Lekker zelf doen</div>
            <p className="text-wrapper-9">
              De focus te leggen op het bewust bijhouden van de vochtinname.&nbsp;&nbsp;De verantwoordelijkheid echt bij
              de patient neer te leggen, maar ze wel tegemoet te komen in het simpel gebruik, wat tegelijk ook efficient
              moet zijn.
            </p>
          </div>
          <div className="frame-9">
            <div className="text-wrapper-8">Altijd bij de hand</div>
            <p className="text-wrapper-9">
              Een smartfone hebben anno 2024 de meeste mensen wel op zak. Hierdoor kan je gemakkelijk altijd je
              vochtinname bij houden via dit apparaat. Een flexibele applicatie die toegankelijk is voor elke gebruiker
              is ons hoofddoel binnen de ontwerprichtlijnen.
            </p>
          </div>
          <div className="frame-9">
            <div className="text-wrapper-8">De zorg ontzorgen</div>
            <p className="text-wrapper-9">
              Door te streven naar een real-time synchronisatie met HIX wordt de communicatie verbeterd en
              administratieve lasten van de zorgverleners worden verminderd.
            </p>
          </div>
        </div>
      </div>
      <div className="frame-3">
        <img className="vector-2" alt="Vector" src="./img/vector-2.svg" />
        <div className="text-wrapper-5">Vorige 3 Concepten</div>
        <div className="frame-4">
          <div className="conceptframe">
            <img className="rectangle" alt="Rectangle" src="./img/rectangle-155.png" />
            <div className="textbox">
              <div className="text-wrapper-10">SmartHydrate</div>
              <p className="text-wrapper-11">
                SmartHydrate is een innovatief systeem ontworpen om hartpatiënten met vochtrestrictie te helpen hun
                vochtinname nauwkeurig te monitoren en bij te sturen. Het systeem maakt gebruik van slimme bekers en
                bakjes die zijn uitgerust met sensoren om het gewicht en volume van eten en drinken te meten. Deze
                gegevens worden automatisch gesynchroniseerd met een mobiele app, waardoor patiënten eenvoudig hun
                vochtinname kunnen bijhouden en aanpassen.
              </p>
            </div>
          </div>
          <div className="conceptframe">
            <div className="textbox">
              <div className="text-wrapper-10">Hydro Vision</div>
              <p className="text-wrapper-11">
                HydroVision is een geavanceerd systeem dat hartpatiënten met een vochtrestrictie helpt om hun
                vochtinname nauwkeurig te monitoren en bij te sturen door gebruik te maken van
                objectherkenningstechnologie en een slimme app. Het systeem herkent automatisch de objecten die
                patiënten eten en drinken, bepaalt de hoeveelheid vocht die ze bevatten, en registreert deze informatie
                in een app.
              </p>
            </div>
            <img className="rectangle" alt="Rectangle" src="./img/rectangle-155-1.png" />
          </div>
          <div className="conceptframe">
            <img className="rectangle" alt="Rectangle" src="./img/rectangle-155-2.png" />
            <div className="textbox">
              <div className="text-wrapper-10">Aqua Guard</div>
              <p className="text-wrapper-11">
                AquaGuard is een geïntegreerd systeem dat hartpatiënten met een vochtrestrictie helpt om hun vochtinname
                nauwkeurig te monitoren en bij te sturen. Het systeem bestaat uit een sensorische armband die de
                vochtbalans in het lichaam meet, en een spraakgestuurde app die de patiënten helpt bij het bijhouden van
                hun dagelijkse vochtinname.
              </p>
            </div>
          </div>
        </div>
        <img className="vector-3" alt="Vector" src="./img/vector-3.svg" />
      </div>
      <div className="div-wrapper">
        <a
          className="text-wrapper-12"
          href="https://www.canva.com/design/DAGFd4Ipuqw/PBRJyz9uJNbI0LRVCO94yw/edit"
          rel="noopener noreferrer"
          target="_blank"
        >
          Studio Blij - Tussenpresentatie
        </a>
      </div>
      <div className="frame-10">
        <img className="vector-3" alt="Vector" src="./img/vector-4.svg" />
        <div className="text-wrapper-5">Eind Product</div>
        <div className="app-image-textbox">
          <img className="img-2" alt="Start" src="./img/start-1.png" />
          <img className="pop-up" alt="Pop up" src="./img/pop-up-1.png" />
          <div className="textbox-2">
            <div className="text-wrapper-10">HydroTrack</div>
            <p className="text-wrapper-11">
              HydroTrack is een combinatie van de concepten Hydro Vision en Aqua guard. Een intuïtieve app die
              vochtinname moeiteloos monitort zonder wearables. HydroTracker biedt de gebruiker verschillende
              invoermethodes aan om hun vochtinname bij te houden. Voor elke type gebruiker is er een manier. Je kan
              namelijk:
              <br />
              <br />
              1. Een camera scan uitvoeren
              <br />
              2. Inspreken
              <br />
              3. Via je toetsenbord de hoeveelheid invoeren
            </p>
          </div>
        </div>
        <div className="app-image-textbox">
          <img className="img-2" alt="Text input" src="./img/text-input-02-2-1.png" />
          <img className="image" alt="Image" src="./img/image-12.png" />
          <div className="textbox-2">
            <div className="text-wrapper-10">Zelfstandigheid</div>
            <p className="text-wrapper-11">
              Patiënten kunnen zelf makkelijk hun vochtinname invoeren zonder moeite, je hoeft niet meer op zoek naar je
              pen en papier of meerdere applicaties tegelijk te gebruiken. Verder heb je zelf de keuze welke methode je
              hanteert.
            </p>
          </div>
        </div>
        <div className="app-image-textbox">
          <img className="img-2" alt="Scannen result" src="./img/scannen-result.png" />
          <img className="img-2" alt="Text to speech" src="./img/text-to-speech-result.png" />
          <div className="textbox-2">
            <div className="text-wrapper-10">Flexibiliteit</div>
            <p className="text-wrapper-11">
              Lekker een kopje koffie doen in de drukke stad? Geen zorgen, type in wat je hebt gedronken. Ben je lekker
              thuis maar heb je geen zin om je leesbril te pakken? Geen probleem, spreek het in of maak simpelweg een
              foto van wat je hebt gegeten of gedronken.
            </p>
          </div>
        </div>
        <div className="app-image-textbox">
          <img className="img-3" alt="Text input" src="./img/text-input-02-2-3.png" />
          <img className="img-3" alt="Overzicht pop up" src="./img/overzicht-pop-up-2.png" />
          <div className="textbox-2">
            <div className="text-wrapper-10">Bewustzijn</div>
            <p className="text-wrapper-11">
              Patiënten worden meer bewust van hun vochtinname, door een inzichtelijke user interface. Verder krijgt de
              gebruiker een notificatie wanneer hij / zij over hun vochtlimiet heen zit.
            </p>
          </div>
        </div>
        <div className="images">
          <div className="image-app" />
          <div className="textbox-3">
            <div className="text-wrapper-10">Invoermethode 1</div>
            <p className="de-speech-to-text">
              <span className="text-wrapper-13">De </span>
              <span className="text-wrapper-3">speech-to-text</span>
              <span className="text-wrapper-13">
                {" "}
                functionaliteit werkt! Alleen is deze echter nog niet verwerkt in een daadwerkelijke applicatie. Het
                advies is om deze code te gebruiken, eenmaal het bovenstaande is al volledig is opgebouwd in een app.
                Bekijk hier onze korte{" "}
              </span>
              <a href="https://youtu.be/WwIwM7dbq5o" rel="noopener noreferrer" target="_blank">
                <span className="text-wrapper-14">
                  demonstratievideo
                  <br />
                </span>
              </a>
            </p>
          </div>
        </div>
        <img className="vector-3" alt="Vector" src="./img/vector-5.svg" />
      </div>
      <div className="frame-11">
        <a
          className="text-wrapper-12"
          href="https://www.canva.com/design/DAGIeC2UZE0/Vdeoqj82wnZ24nfxM7hR0A/edit"
          rel="noopener noreferrer"
          target="_blank"
        >
          Studio Blij - Eindpresentatie
        </a>
      </div>
      <div className="aanbevelingen">
        <img className="vector-3" alt="Vector" src="./img/vector-6.svg" />
        <div className="frame-7">
          <div className="text-wrapper-7">Aanbevelingen</div>
          <div className="frame-8">
            <div className="frame-9">
              <div className="text-wrapper-8">Onboarding</div>
              <p className="text-wrapper-9">
                Gezien er meerdere invoermethodes zijn, welke ook weer aan een specifiek soort gebruiker of situatie
                gekoppeld kunnen worden. Hierdoor is het handig om de patiënt te voorzien van een onboarding.
                <br />
                Dit wilt zeggen dat de applicatie de gebruiker meeneemt in hoe hij / zij zo efficiënt mogelijk de
                applicatie kan gebruiken.
              </p>
            </div>
            <div className="frame-9">
              <div className="text-wrapper-15">
                Testen met
                <br />
                diverse gebruikers
              </div>
              <p className="text-wrapper-9">
                Gezien er meerdere gebruikers zijn of verschillende scenario&#39;s, kan het verschillen wie welke
                invoermethode gebruikt en wanneer. Daarom is het belangrijk om met verschilde patiënten te testen.
                Patiënten met spraakproblemen, welke misschien slechtziend 
                <br />
                zijn of andere beperking hebben.
              </p>
            </div>
            <div className="frame-9">
              <div className="text-wrapper-15">
                Uitwerken <br />
                invoermethodes
              </div>
              <p className="text-wrapper-9">
                We hebben tijdens dit project nog niet alle invoermethodes werkzaam gekregen. Hiernaast hebben wij ook
                de invoermethodes niet binnen de tijd weten te verwerken in een&nbsp;&nbsp;applicatie. Wel is de
                volledige flow en navigatie uitgewerkt, welke kan worden aangehouden voor de verdere ontwikkeling van de
                volledige applicatie.
              </p>
            </div>
          </div>
        </div>
        <div className="frame-12">
          <img className="vector-3" alt="Vector" src="./img/vector-7.svg" />
          <div className="text-wrapper-5">Namens het team, bedankt!</div>
          <div className="frame-13">
            <div className="teamlid">
              <img className="IMG-copy" alt="Img copy" src="./img/img-4337-copy.svg" />
              <div className="text-wrapper-16">Casper</div>
            </div>
            <div className="teamlid">
              <img className="IMG-copy" alt="Img copy" src="./img/img-4337-copy-1.svg" />
              <div className="text-wrapper-16">Elize</div>
            </div>
            <div className="teamlid">
              <img className="IMG-copy" alt="Img copy" src="./img/img-4337-copy-2.svg" />
              <div className="text-wrapper-16">Merel</div>
            </div>
            <div className="teamlid">
              <img className="IMG-copy" alt="Img copy" src="./img/img-4337-copy-3.svg" />
              <div className="text-wrapper-16">Laura</div>
            </div>
            <div className="teamlid">
              <img className="IMG-copy" alt="Img copy" src="./img/img-4337-copy-4.svg" />
              <div className="text-wrapper-16">Stevie</div>
            </div>
            <div className="teamlid">
              <img className="IMG-copy" alt="Img copy" src="./img/img-4337-copy-5.svg" />
              <div className="text-wrapper-16">Ola</div>
            </div>
          </div>
          <img className="IMG-JPEG" alt="Img JPEG" src="./img/img-6056-jpeg-1.png" />
          <div className="frame-14">
            <div className="text-wrapper-17">© Studio Blij 2024</div>
            <div className="frame-15">
              <img className="hogeschool-rotterdam" alt="Hogeschool rotterdam" src="./img/hogeschool-rotterdam-1.svg" />
              <img className="erasmus-MC-logo" alt="Erasmus MC logo" src="./img/erasmus-mc-logo.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
